
import { defineComponent, ref, computed } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in",
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  },
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const showPassword = ref(false);
    const password = ref("");

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().email().required().label("Email"),
      password: Yup.string()
      .min(6)
      .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
      .matches(/[a-z]/, 'Must contain at least one lowercase letter')
      .matches(/[0-9]/, 'Must contain at least one number')
      .matches(/[^A-Za-z0-9]/, 'Must contain at least one special character')
      .required()
      .label("Password"),
    });



    const passwordType = computed(() => {
      if (showPassword.value) {
        return `text`;  
      }
      return `password`;
    });

    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      store
        .dispatch(Actions.LOGIN, values)
        .then(() => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          router.push({ name: "dashboard" });
        })
        .catch(() => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          Swal.fire({
            text: store.getters.getErrors[0],
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
      showPassword,
      password,
      passwordType,
    };
  },
});
